import React from 'react'
// view components
import DetailsForm from './components/DetailsForm'
// components
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/view'
// themes
import { colors } from 'themes'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
// context
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'

const ObjectDetails: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const { object } = React.useContext(ObjectsAPIContext)

  const expandPanel = (_, expanded) => setIsOpen(expanded)

  const initialValues = {
    name: object.name,
    apiName: object.apiName
  }

  return (
    <Accordion expanded={isOpen} onChange={expandPanel}>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>Details</AccordionSummary>
      <AccordionDetails>
        <DetailsForm initialValues={initialValues} />
      </AccordionDetails>
    </Accordion>
  )
}

export default ObjectDetails
